var AbstractDataModel = require("./AbstractDataModel")
var ForecastWS = require("../ws/ForecastWS");
var TransactionTypeModel = require("./TransactionTypeModel");
var getQueryParam = require("../helpers/viewmodels").getQueryParam
var DisplayPhone = require("../lib/display-phone")
var normalisedTelephoneNumber = require("../lib/phone").normaliseTelephoneNumber
var formatConsumerName = require("../lib/format-consumer-name").formatConsumerName

/**
 * An object representing a consumer in line
 *
 * @constructor
 * @param {JSON} obj
 * @returns {SpotModel}
 * 
 * @property {Object<string, string>} customProps
 */
function SpotModel(obj) {
  var self = this;

  /**
   * @type {null|Object<string, string>}
   */
  var customProps = [];
  var l = null;
  var parts = [];
  var q = null;
  var tt = null;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractDataModel.apply(self, arguments);

  self.language = null;
  self.name = ko.observable(null);
  self.sessionId = -1;

  // If data was passed in, initialize the object
  if (obj) {

    if (getQueryParam('debug') === 'true') {
      self.data = obj;
    }

    Object.assign(self, obj);

    self.dateArrived = self.parseDate(obj.arrived);
    self.dateEntered = self.parseDate(obj.dateEntered);
    self.dateReserved = self.parseDate(obj.dateReserved);
    self.dateTicketIssued = self.parseDate(obj.dateTicketIssued);
    self.dateTicketRedeemed = self.parseDate(obj.dateTicketRedeemed);
    self.name = ko.observable(obj.name);

    if (obj.originalForecast) {
      self.originalForecastDuration = obj.originalForecast.duration;
      self.originalForecastUnits = obj.originalForecast.units;
    }

    if (obj.timeQueued) {
      self.timeQueuedDuration = obj.timeQueued.duration;
      self.timeQueuedUnits = obj.timeQueued.units;
    }

    if (obj.phone && typeof obj.phone === 'object') {
      // This pattern matches the data in the Arrived List
      if (Array.isArray(obj.phone)) {
        self.countryCode = obj.phone[1].countryCode;
        self.phone = obj.phone[1].text && String(obj.phone[1].text);
      }
      // This pattern matches other consumers
      else {
        self.countryCode = self.phone.countryCode;
        self.phone = self.phone.text && String(self.phone.text);
      }
    }

    if (obj.privateName) {
      self._privateName = obj.privateName;
    }

    tt = Array.makeArray(obj.transactionType);
    if (tt && tt.length > 0) {
      self.transactionType = new TransactionTypeModel(tt[0]);
      self.transactionTypeId = tt[0].id;
    }

    customProps = Array.makeArray(obj.customProp);
    self.customProps = (customProps && customProps.length > 0) ? customProps : []

    if (obj.locale) {
      parts = obj.locale.split('_');

      if (parts[0].toLowerCase() != 'en') {
        self.language = vm.messagesWS.get('language.' + parts[0].toLowerCase());
      }
    }

    if (obj.queueId != null) {
      q = vm.queuesWS.getQueueById(obj.queueId);

      if (q) {
        self.queueName = q.description;
        l = vm.locationsWS.getLocationById(q.locationId);
      }

      self.locationName = (l) ? l.description : '';
    }

    if (typeof self.notes === 'object') {
      if (self.notes.hasOwnProperty('text')) {
        self.notes = obj.notes.text;
      }
      else {
        self.notes = '';
      }
    }

    if (obj.actionLinks && obj.actionLinks.actionLink) {
      self.actionLinks = Array.makeArray(obj.actionLinks.actionLink);
    }
  };

  // API service transactors
  self.forecastWS = new ForecastWS(self.id, self.sessionId, self.queueId);

  // Exposed members from API call returns
  self.forecastDuration = self.dependentObservable('duration', self.forecastWS);
  self.forecastUnits = self.dependentObservable('units', self.forecastWS);
  self.variance = ko.observable(0);

	/**
	 * Determines the private name to display for the Consumer
	 *
	 * @method privateName
	 * @returns {String}
	 */
  self.privateName = function () {
    var q = vm.queuesWS.getQueueById(self.queueId);
    var displayedText = null;

    if (q) {
      var privatePhoneDigitCount = q.privatePhoneDigitCount;

      var normalisedNumber = DisplayPhone.removeDefaultCountryCode(
        normalisedTelephoneNumber(self.phone),
        (self.countryCode) ? self.countryCode : q.defaultPhoneCountryCode() 
      )

      var privateName = window.vm.getPrivateName(
        normalisedNumber,
        self._privateName,
        undefined, privatePhoneDigitCount
      );

      displayedText = formatConsumerName({
        privateName, // already masked by `window.kiosk.getPrivateName`
        merchantInfoName: self.merchantInfoName,
        firstName: self.firstName,
        lastName: self.lastName,
        name: self.name(),
        phone: self.phone,
        receiptNumber: self.receiptNumber
      })
    }

    return displayedText;
  };

  self.classNames = ko.computed(self._className.bind(self));
  self.isExpired = ko.computed(self._isExpired.bind(self));
  self.isLastInLine = ko.computed(self._isLastInLine.bind(self));
  self.isSummoned = ko.computed(self._isSummoned.bind(self));
  self.consumerPrivateName = ko.computed(self._consumerPrivateName.bind(self));
  self.queue = ko.computed(self._queue.bind(self));

  /**
   * Transform the array of Custom Props into a simple object.
   */
  self.customPropsAsObject = function () {
    return self.customProps.reduce(function (customProps, customProp) {
      customProps[customProp.name] = customProp.value;
      return customProps;
    }, {})
  }

  return self;
}


SpotModel.prototype = Object.create(AbstractDataModel.prototype);
SpotModel.prototype.constructor = SpotModel;


/**
 * Specifies the time of the appointment, if exists
 *
 * @returns {String | Null}
 */
SpotModel.prototype.appointmentTime = function () {
  if (this.appointment) {
    var time = new Date(Date.parse(this.appointment.start));
    return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  return null;
};


/**
 * Returns the time the Consumer was was marked as arrived
 *
 * @returns {String}
 */
SpotModel.prototype.arrivedTime = function () {
  var m = moment(this.dateArrived.valueOf());
  return m.format('LT');
};


/**
 * Allows for retrieval of a named custom property, to aid
 * in the display of list view
 *
 * @param  {string} name
 * @returns {String}
 */
SpotModel.prototype.customPropByName = function (name) {
  var value = '';

  if (this.customProps) {
    this.customProps.forEach(function (prop) {
      if (prop.name === name) {
        value = prop.value;
      }
    });
  }

  return value;
};


/**
 *
 * @param {Array} customFieldNames
 * @returns {Array}
 */
SpotModel.prototype.listViewCustomFields = function (customFieldNames) {
  var self = this;
  var arr = [];

  if (customFieldNames) {
    customFieldNames.forEach(function (name) {
      var found = false;
      if (self.customProps) {
        self.customProps.forEach(function (prop) {
          if (prop.name === name) {
            found = true;
            arr.push(prop.value);
          }
        });
      }

      if (!found) {
        arr.push('');
      }
    });
  }

  return arr;
};


/**
 * Returns a phone number, only displaying the last
 * 'privatePhoneDigitCount' numbers. The rest will be masked from view
 *
 * @returns {String}
 */
SpotModel.prototype.maskedPhone = function () {
  var self = this;
  var a = null;
  var b = null;
  var matches = null;
  var phone = self.phone && String(self.phone);
  var q = vm.queuesWS.getQueueById(self.queueId);

  if (!phone) {
    return null;
  }

  privatePhoneDigitCount = (q && q.privatePhoneDigitCount) || 4;

  b = phone.substring(phone.length - privatePhoneDigitCount);
  matches = b.match(/[^0-9]/g);
  privatePhoneDigitCount += (matches) ? matches.length : 0;


  a = phone.substring(0, phone.length - privatePhoneDigitCount).replace(/[0-9]/g, '#');
  b = phone.substring(phone.length - privatePhoneDigitCount);

  return a + b;
};


/**
 * Determines whether the parent queue supports call ahead
 *
 * @returns {Boolean}
 */
SpotModel.prototype.showCallAhead = function () {
  if (this.queue()) {
    return this.queue().supportsCallAhead === true;
  }
  return false;
};


/**
 * Will return a string value if the user has a valid
 * skipped reason. Otherwise will return null
 *
 * @returns {String}
 */
SpotModel.prototype.skippedReason = function () {
  if (this.issueSkipped && vm.skippedReasons.indexOf(this.issueSkippedReason) > -1) {
    return vm.messagesWS.get('skipped.reason.' + this.issueSkippedReason);
  }
  return null;
};


/**
 * Returns the time the Consumer was summoned for service
 *
 * @returns {String}
 */
SpotModel.prototype.ticketIssueTime = function () {
  var m = moment(this.dateTicketIssued.valueOf());
  return m.format('LT')
};


/**
 * Retrieves the variance time from the web service results
 *
 * @returns none
 */
SpotModel.prototype.updateVariance = function () {
  var self = this;
  var variance = vm.variancesWS.getVarianceBySessionId(self.sessionId);
  self.variance(variance);
  return variance;
};


/**
 * Adds attribute className info to the spot
 *
 * @returns {Array}
 */
SpotModel.prototype._className = function () {
  var self = this;
  var className = 'consumer-status-';
  var  variance = self.variance();

  if (self.callAhead) {
    className += 'callahead';
  }
  else if (self.appointment) {
    className += 'appointment';
  }
  else if (variance > .5) {
    className += 'variancebad';
  }
  else if (variance > .25) {
    className += 'varianceslight';
  }
  else {
    className += 'good';
  }

  if (vm.selectedConsumer() && vm.selectedConsumer().sessionId === self.sessionId) {
    className += ' sel';
  }

  return className;
}


/**
 * Determines if the consumer is in the list of expired consumers
 *
 * @returns {Boolean}
 */
SpotModel.prototype._isExpired = function () {
  var self = this;
  var found = false;
  var q = vm.queuesWS.getQueueById(self.queueId);

  if (q && q.expiredTickets()) {
    q.expiredTickets().forEach(function (spot) {
      if (spot.sessionId === self.sessionId) {
        found = true;
      }
    });
  }

  return found;
};


/**
 * Conveys whether the consumer is the last in line
 *
 * @returns {Boolean}
 */
SpotModel.prototype._isLastInLine = function () {
  var self = this;
  // Get a reference to the queue the consumer is in
  var q = vm.queuesWS.getQueueById(self.queueId);

  if (q) {
    var spots = q.spots();
    // If the consumer is the same as the last spot in line,
    // the return true
    return (spots[spots.length - 1] == self);
  }

  return false;
};


/**
 * Determines if the consumer is in the list of summoned consumers
 *
 * @returns {Boolean}
 */
SpotModel.prototype._isSummoned = function () {
  var self = this;
  var found = false;
  var q = vm.queuesWS.getQueueById(self.queueId);

  if (q && q.tickets()) {
    q.tickets().forEach(function (spot) {
      if (spot.sessionId === self.sessionId) {
        found = true;
      }
    });
  }

  return found;
};


/**
 * Determines the consumer name with the ticket classifier for the consumer
 *
 * @returns {String}
 */
SpotModel.prototype._consumerPrivateName = function () {
  var self = this;
  var tc = self.ticketClassifier;
  return (tc && tc.description && tc.description.length > 0) ? self.privateName() + " - " + tc.description : self.privateName();
};


/**
 * Returns the queue the Consumer belongs to
 *
 * @returns {QueueModel}
 */
SpotModel.prototype._queue = function () {
  return vm.queuesWS.getQueueById(this.queueId);
};

SpotModel.prototype.ticketClassifierDescription = function() {
  if (this.ticketClassifier && this.ticketClassifier.description) {
    return this.ticketClassifier.description;
  }
  else if (this.classifier && this.classifier.description) {
    return this.classifier.description;
  }
  else {
    return "";
  }
}

SpotModel.prototype.transactionTypeDescription = function () {
 return (this.transactionType && this.transactionType.description) ? this.transactionType.description : '';
}

SpotModel.prototype.customPropsForDisplay = function () {
  // QDEV-7384 - Some Merchants bypass "Required" fields with a blank space
  // because CEC 'Add Consumer' dialog allows blank spaces to be input into
  // required fields (Yes, we should not allow this but that's a later decision)

  // When this happens, the custom prop is present in the Spot data but lacks a
  // `value` attribute:
  // 
  // <customProp name="Student_ID"/>
  // vs 
  // <customProp name="Student_ID" value="12345" />
  // 
  // So, when displaying Custom Props in the Consumer metadata, we filter out
  // custom props that do not have a value.
  return this.customProps.filter(p => p.value !== undefined)
}

SpotModel.prototype.hasARealName = function () {
  return this.firstName !== "" && this.firstName !== null && typeof this.firstName !== "undefined"
}

SpotModel.prototype.canShowTicketNumber = function () {
  return (this.receiptNumber && !this.hasARealName())
    || (this.phone && this.receiptNumber && this.hasARealName())
}


if (typeof exports !== "undefined") {
module.exports = SpotModel;
}

